import { ReactNode } from 'react';
import './RFQTeaser.scss';

export const RFQTeaser = ({ children }: { children: ReactNode }) => <div className="rfq-list-teaser">{children}</div>;
